import React from 'react';

import {RouteData} from '../types';
import {RUN_PATHS} from './singleRunWorkspacePaths';

export const SINGLE_RUN_WORKSPACE_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: true,
      routeName: 'Run',
    },
    exact: true,
    isPrivateRoute: false,
    path: RUN_PATHS,
    RouteComponent: React.lazy(() => import('../../pages/RunPage2')),
  },
];
